/**
 * Mutates currentDripItem array.
 * Replaces the item having same contentPostId.
 */
export function replaceDripItemByContentPostId(currentDripItem, newItem) {
  const index = currentDripItem.findIndex(
    i => Number(i.contentPostId) === Number(newItem.contentPostId)
  );

  if (index !== -1) {
    // mutate (replace in same array reference)
    currentDripItem[index] = newItem;
    return true;
  }

  return false;
}
